import { AddCircle } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NewLayoutDialog } from './new-dialog';

export const NewLayoutButton = () => {
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Button
        color="primary"
        onClick={() => setDialogOpen(true)}
        startIcon={<AddCircle />}
        variant="contained"
      >
        {t('pages.layouts.actions.new_layout')}
      </Button>

      <NewLayoutDialog close={() => setDialogOpen(false)} open={dialogOpen} />
    </>
  );
};
